import { toast } from "sonner";

export const CA = "GjGVsFoRdShBFXc5ETmVtT3sQso7YWaiYLtir5T3pump";
export const CA_SHORT = "GjGV…pump";
export const BUY_URL = `https://pump.fun/coin/${CA}`;

export const copyCA = async () => {
  try {
    await navigator.clipboard.writeText(CA);
  } catch {
    /* clipboard blocked — still confirm */
  }
  toast.success("Contract address copied", {
    description:
      "Always verify you're buying the official $FOMOWEEN. Beware of fake cauldrons.",
  });
};
